export default [
     //FOR Branch User to View the PO========================================================================
     {
        key: "viewPOSubmittedToMD",
        status: "Submitted To MD",
        label: "This PO has been Approved By Finance And Submitted to MD",
        reject_reason: "",
        actionButtons: [

        ]
    },
     {
        key: "viewPOApproveMD",
        status: "Approved PO",
        label: "This PO has been Approved MD",
        reject_reason: "",
        actionButtons: [

        ]
    },
      //------------------------------------------------------------------------------------------------------
    //FOR BRANCH USER==========================================================================
    {
        key: "PO Pending Approval",
        status: "PO Pending Approval",
        label: "Evaluate this PO and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted To MD",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve & Submit To MD",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PO?",
                successMessage: "This PO has been successfully Approved and submitted to MD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "PO Rejected By FM",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this PO?",

                buttonLabel: "Reject this PO",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PO has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },
    {
        key: "Submitted To MD",
        status: "Submitted To MD",
        label: "This PO has been Approved And Submitted to MD",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "poApprovedByMD",
        status: "Approved PO",
        label: "This PO has been Approved By MD",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "poRevised",
        status: "Approved PO",
        label: "This PO has been Revised",
        reject_reason: "",
        actionButtons: [ 
            { 
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Cancel PO",
                },
 
                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Cancel PO",
                rejectReasonMessage: "Why do you want to reject this PO?",

                buttonLabel: "Cancel PO",
                color: 'danger',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Cancellation",
                confirmationMessage: "Are you sure you want to cancel this PO?",
                successMessage: "This PO has been successfully cancelled",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
        ]
    }, 
    {
        key: "poApprovedByMDForRevised",
        status: "Approved PO",
        label: "This PO has been Approved By MD",
        reject_reason: "", 
        actionButtons: [
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Submitted To MD For Revise",
                },
 
                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: " ",

                buttonLabel: "Re-submit to MD for revision",
                color: 'success',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to submit this to your MD?",
                successMessage: "This PO has been successfully Submitted to your MD",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            { 
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Cancel PO",
                },
 
                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Cancel PO",
                rejectReasonMessage: "Why do you want to reject this PO?",

                buttonLabel: "Cancel PO",
                color: 'danger',
                icon: "icon-send",
                btnSize: "large",

                confirmationTitle: "Cancellation",
                confirmationMessage: "Are you sure you want to cancel this PO?",
                successMessage: "This PO has been successfully cancelled",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
        ]
    },
    {
        key: "PO Rejected By FM",
        status: "PO Rejected By FM",
        label: "This PO has been Rejected by Finance",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "PORejectedByMD",
        status: "PO Rejected By MD",
        label: "This PO has been Rejected by MD",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "CLOSED PO",
        status: "CLOSED PO",
        label: "This PO is CLOSED",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "poToClose",
        status: "Approved PO",
        label: "Enter Invoice Number to close this PO",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "CLOSED PO",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Closed PO",
                rejectReasonMessage: "Enter Invoice number?",

                buttonLabel: "Close this PO",
                color: 'success',
                icon: "icon-check-circle",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PO has been successfully Closed",

                sucessEventName: "changeView",
                successEventValue: "list",
            }
        ]
    },

    //------------------------------------------------------------------------------------------
    //FOR Managing Director========================================================================
    {
        key: "submittedToMD",
        status: "Submitted To MD",
        label: "Evaluate this PO and Approve or Reject it.",
        reject_reason: "",
        actionButtons: [
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "Approved PO",
                },

                getReason: false,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "",
                rejectReasonMessage: "",

                buttonLabel: "Approve PO",
                color: 'success',
                icon: "icon-thumbs-up",
                btnSize: "large",

                confirmationTitle: "Submission",
                confirmationMessage: "Are you sure you want to Approved this PO?",
                successMessage: "This PO has been successfully Approved.",

                sucessEventName: "changeView",
                successEventValue: "list",
            },
            {
                endPoint: "updatePOStatus",
                payLoad: {
                    id: "", //record Id To Update
                    newStatus: "PO Rejected By MD",
                },

                getReason: true,//if True, a popup will show to ask user to type the reason
                rejectDialogTitle: "Reject Confirmation",
                rejectReasonMessage: "Why Are you Rejecting this PO?",

                buttonLabel: "Reject this PO",
                color: 'danger',
                icon: "icon-thumbs-down",
                btnSize: "large",

                confirmationTitle: "Rejection",
                confirmationMessage: "",
                successMessage: "This PO has been successfully Rejected",

                sucessEventName: "changeView",
                successEventValue: "list",
            }

        ]

    },
    {
        key: "APPROVED PO",
        status: "Approved PO",
        label: "This PO has been Approved",
        reject_reason: "",
        actionButtons: [

        ]
    },
    {
        key: "PO Rejected By MD",
        status: "PO Rejected By MD",
        label: "This PO has been Rejected",
        reject_reason: "",
        actionButtons: [

        ]
    },
    //------------------------------------------------------------------------------------------
]